import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';

/**
 * Shared RTK Query API. Feature endpoints are injected into this single api
 * via `baseApi.injectEndpoints(...)` (see each feature's `*Api.ts`).
 *
 * `tagTypes` are declared once here so any feature can provide/invalidate them
 * for automatic cache refetching (e.g. a task mutation invalidates 'Project'
 * so the leadership dashboard roll-up refreshes).
 *
 * Uses a custom Axios-based baseQuery that SigV4-signs every request for
 * CloudAuth validation on the Coral backend.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery,
  tagTypes: [
    'Project',
    'Task',
    'User',
    'Audit',
    'CandidatePool',
    'FunctionalOwner',
  ],
  endpoints: () => ({}),
});
